module.exports = __webpack_public_path__ + "static/3-dabd170e0c7b88b23c2a9298db70109c.png";